import { render, staticRenderFns } from "./androidinfo.vue?vue&type=template&id=867a403a&scoped=true"
import script from "./androidinfo.vue?vue&type=script&lang=js"
export * from "./androidinfo.vue?vue&type=script&lang=js"
import style0 from "./androidinfo.vue?vue&type=style&index=0&id=867a403a&lang=scss&scoped=true"
import style1 from "./androidinfo.vue?vue&type=style&index=1&id=867a403a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867a403a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('867a403a')) {
      api.createRecord('867a403a', component.options)
    } else {
      api.reload('867a403a', component.options)
    }
    module.hot.accept("./androidinfo.vue?vue&type=template&id=867a403a&scoped=true", function () {
      api.rerender('867a403a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firmware/androidinfo.vue"
export default component.exports